import {
  Box,
  Chip,
  FormHelperText,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import CustomDropzone from "global/components/CustomDropzone/CustomDropzone";
import DropZoneIcon from "assets/icons1/dropzone_icon.svg";
import { useContext, useState } from "react";
import { ContactContext } from "../Context";
import notifiers from "global/constants/NotificationConstants";
import {
  openErrorNotification,
  getFileExtension,
  isTruthy,
} from "helpers/methods";
import { expectedColumnNames } from "screens/Contacts/Helpers";
import { getFileColumnType } from "screens/Contacts/ContactsService";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import CrossIcon from "assets/icons1/chip_delete_icon.svg";

const AddContactDropezoneComponent = () => {
  const {
    formFields,
    setFormFields,
    setParsingCsvData,
    parsingCsvData,
    setColumnMatch,
    setCsvColumn,
  } = useContext(ContactContext);
  const [isLoading, setLoading] = useState<boolean>(false);
  const handleFieldChange = (fieldName: string, updatedValue: any) => {
    if (fieldName === "groupCSV") {
      setFormFields({
        ...formFields,
        [fieldName]: {
          value: updatedValue,
          error: "",
        },
      });
    }
  };

  const handleOnDropZoneFile = (file: any) => {
    handleFieldChange("groupCSV", file);
  };

  const handleDeleteDropZoneFile = () => {
    handleFieldChange("groupCSV", "");
    setColumnMatch(false);
  };

  const checkExpectedColumnHaveSameElement = (
    expectedColumnNames: string[],
    actualColumnNames: { [key: string]: string }
  ) => {
    if (expectedColumnNames.length !== Object.keys(actualColumnNames).length) {
      return false;
    }

    return expectedColumnNames.every((column) =>
      actualColumnNames.hasOwnProperty(column)
    );
  };

  const getParsedCSVColumnNames = async (file: any) => {
    try {
      setLoading(true);
      const fileDetails = file[0];
      const formData = new FormData();
      formData.append("file", fileDetails);

      if (fileDetails.size > 85000000) {
        setLoading(false);
        return openErrorNotification(
          `The ${fileDetails.name} file exceeds the size limit of 85 MB.`
        );
      }
      if (formData !== undefined) {
        if (["csv"].includes(getFileExtension(fileDetails.name))) {
          const response = await getFileColumnType(formData);

          const columnsMatch = checkExpectedColumnHaveSameElement(
            expectedColumnNames,
            response
          );

          setCsvColumn((prevCsvColumns: any) =>
            prevCsvColumns.map((col: any) => {
              if (col.name === "Email") {
                const match = Object.keys(response).find(
                  (key) => key === "EMAIL_ID"
                );
                return {
                  ...col,
                  fieldMapping: match || "",
                };
              }

              const match = Object.keys(response).find(
                (key) =>
                  key.toLowerCase() ===
                  col.name.replace(/\s+/g, "_").toLowerCase()
              );

              return {
                ...col,
                fieldMapping: match || "",
              };
            })
          );
          setParsingCsvData({
            ...parsingCsvData,
            isOpen: true,
            csvData: response,
          });
          handleOnDropZoneFile(fileDetails);
          setLoading(false);
        } else {
          openErrorNotification("Please upload document in csv format!");
          setLoading(false);
        }
      } else {
        openErrorNotification(
          "No document selected, please upload document again."
        );
        setLoading(false);
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
      setLoading(false);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Stack display={"flex"} flexDirection={"column"}>
          <CustomDropzone
            sx={{ height: "8rem" }}
            onAdd={(file: any) => {
              getParsedCSVColumnNames(file);
            }}
            maxFileSize={85 * 1024 * 1024}
            acceptedFiles={[".csv"]}
            showAlerts={false}
            multipleFileUpload={false}
            dropzoneText={"Choose a file or drag & drop it here"}
            icon={DropZoneIcon}
          />
          {isTruthy(formFields.groupCSV.error) && (
            <FormHelperText error sx={{ paddingTop: "6px" }}>
              {formFields.groupCSV.error}
            </FormHelperText>
          )}
          <Typography
            variant="subtitle2"
            color={"#FF9436"}
            pt={1}
            sx={{
              opacity: 0.9,
            }}
          >
            * The file must be in .csv format, with a maximum size of 85 MB.
          </Typography>
          {isTruthy(formFields?.groupCSV?.value?.name) && (
            <Box>
              <Chip
                label={formFields?.groupCSV?.value?.name}
                variant="filled"
                sx={{ mt: 1 }}
                deleteIcon={
                  <img
                    src={CrossIcon}
                    style={{
                      paddingTop: "2px",
                      width: "25px",
                    }}
                    alt="cross_icon"
                  />
                }
                onDelete={handleDeleteDropZoneFile}
              />
            </Box>
          )}
        </Stack>
      </Grid>
      <CustomLoader isLoading={isLoading} />
    </>
  );
};

export default AddContactDropezoneComponent;
